import { auth } from "../../../services/firebase";
import { signInWithCustomToken } from "firebase/auth";
import { postData, fetchData } from "../../../services/api";

export const sendVerification = async (formData) => {
  try {
    const data = await postData("auth/send-verification", formData);

    if (data.errors) {
      return { success: false, errors: data.errors };
    }
    return { success: true, data };
  } catch (error) {
    console.error("Error:", error);
    return {
      success: false,
      errors: error,
    };
  }
};

export const verifyCode = async (formData) => {
  try {
    console.log("Verifying code in authService:", formData);
    const data = await postData(
      "auth/verify-code",
      {
        code: formData.userCode,
      },
      {
        credentials: "include",
      }
    );

    if (data.errors) {
      return { success: false, errors: data.errors };
    }

    // If verification is successful, the cloud function will have already:
    // 1. Registered the user
    // 2. Generated an anonymous auth token
    // We just need to sign in with the token
    if (data.token) {
      await signInWithCustomToken(auth, data.token);
    }

    return { success: true, data };
  } catch (error) {
    console.error("Error:", error);
    if (error.message.includes("Verification code expired")) {
      return {
        success: false,
        errors: {
          code: "Verification code has expired. Please request a new one.",
        },
      };
    }
    return {
      success: false,
      errors: error,
    };
  }
};

export const completeInterview = async () => {
  try {
    return await postData("video/complete-interview", {});
  } catch (error) {
    console.error("Error completing interview:", error);
    throw error;
  }
};

export const getUsers = async () => {
  try {
    return await fetchData("auth/get-users");
  } catch (error) {
    console.error("Error:", error);
    return {
      success: false,
    };
  }
};
